var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99991 3.41L8.57991 8L3.99991 12.59L5.40991 14L11.4099 8L5.40991 2L3.99991 3.41Z",
    fill: "#F0EDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextGrey);
export default __webpack_public_path__ + "static/media/nextGrey.15c858ab66147531819643e472fef55d.svg";
export { ForwardRef as ReactComponent };